import type { ReactNode } from "react";

/**
 * JSON syntax highlighting.
 *
 * Tokenised rather than regex-replaced over escaped HTML: the previous console
 * matched `"…":` against already-escaped text, which mangled any value
 * containing a quote or an ampersand — and YouTube titles are full of both.
 * Returning React nodes also means nothing is ever injected as raw HTML.
 */
const TOKEN =
  /("(?:\\.|[^"\\])*")(\s*:)|("(?:\\.|[^"\\])*")|(-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)|\b(true|false)\b|\b(null)\b/g;

export function highlightJson(source: string): ReactNode {
  const out: ReactNode[] = [];
  let last = 0;
  let i = 0;

  for (const m of source.matchAll(TOKEN)) {
    const start = m.index;
    if (start > last) out.push(source.slice(last, start));

    const [, keyText, colon, stringText, numberText, boolText, nullText] = m;

    if (keyText) {
      out.push(
        <span className="j-key" key={i++}>
          {keyText}
        </span>,
        colon,
      );
    } else if (stringText) {
      out.push(
        <span className="j-string" key={i++}>
          {stringText}
        </span>,
      );
    } else if (numberText) {
      out.push(
        <span className="j-number" key={i++}>
          {numberText}
        </span>,
      );
    } else if (boolText) {
      out.push(
        <span className="j-bool" key={i++}>
          {boolText}
        </span>,
      );
    } else if (nullText) {
      out.push(
        <span className="j-null" key={i++}>
          {nullText}
        </span>,
      );
    }

    last = start + m[0].length;
  }

  if (last < source.length) out.push(source.slice(last));
  return out;
}
